import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home';
import ThingsToDo from './ThingsToDo';
import SeatingChart from './SeatingChart';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/things-to-do" element={<ThingsToDo />} />
        {/* Future routes */}
        <Route path="/guest-list" element={<ComingSoon page="Guest List" />} />
        <Route path="/seating" element={<SeatingChart />} />
        <Route path="/photos" element={<ComingSoon page="Photo Album" />} />
      </Routes>
    </BrowserRouter>
  );
}

function ComingSoon({ page }) {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#FDF8F3' }}>
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4" style={{ color: '#C87941' }}>
          {page}
        </h1>
        <p className="text-xl text-gray-600 mb-8">Coming Soon!</p>
        <a
          href="/"
          className="inline-block px-6 py-3 rounded-lg text-white font-semibold"
          style={{ backgroundColor: '#C87941' }}
        >
          ← Back to Home
        </a>
      </div>
    </div>
  );
}

export default App;
